import { PrettySelectOption } from './pretty-select.component';

/** Standard page-size options for any paginated list. */
export const PAGE_SIZE_OPTIONS: PrettySelectOption<number>[] = [
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
];

/** Standard sex options for the user form. */
export const SEX_OPTIONS: PrettySelectOption<'HOMME' | 'FEMME' | ''>[] = [
  { value: '', label: 'Non précisé' },
  { value: 'HOMME', label: 'Homme' },
  { value: 'FEMME', label: 'Femme' },
];

/** Keycloak permission decision strategies. */
export const DECISION_STRATEGY_OPTIONS: PrettySelectOption<
  'UNANIMOUS' | 'AFFIRMATIVE' | 'CONSENSUS'
>[] = [
  { value: 'UNANIMOUS', label: 'UNANIMOUS', hint: 'toutes autorisent' },
  { value: 'AFFIRMATIVE', label: 'AFFIRMATIVE', hint: 'au moins une' },
  { value: 'CONSENSUS', label: 'CONSENSUS', hint: 'majorité' },
];

/** Permission type discriminator. */
export const PERMISSION_TYPE_OPTIONS: PrettySelectOption<'scope' | 'resource'>[] = [
  { value: 'scope', label: 'scope', hint: 'basé sur des actions' },
  { value: 'resource', label: 'resource', hint: 'resource entière' },
];

/** Bulk role-permission operation. */
export const BULK_OP_OPTIONS: PrettySelectOption<'ADD' | 'REMOVE'>[] = [
  { value: 'ADD', label: 'Ajouter' },
  { value: 'REMOVE', label: 'Retirer' },
];
